import { cn } from "@wags/ui/ui-utils";

type Litter = { label: string };

export function UpcomingLittersRow({
    litters,
    className,
}: {
    litters?: Litter[];
    className?: string;
}) {
    if (!litters || litters.length === 0) return null;
    return (
        <div className={cn("flex flex-wrap gap-2", className)}>
            {litters.map((litter) => (
                <span
                    key={litter.label}
                    className="rounded-label bg-doberman-black/[0.04] px-3 py-1.5 text-body-small text-doberman-black/80"
                >
                    {litter.label}
                </span>
            ))}
        </div>
    );
}
